import { DataTable } from 'pepsico-ds'
import React, { useRef } from 'react'
// import * as XLSX from 'xlsx';
// import { saveAs } from 'file-saver';
import { exportRowsToExcel } from '../../utils/excelExport';
import { saveAs } from 'file-saver';
import InfoIcon from '../Icons/InfoIcon';
import download_logo from '../../assets/download_logo.png'
import domtoimage from "dom-to-image";
import jsPDF from "jspdf";
import DropdownWithIcons from '../Modal/DropdownWithIcons';
import { useToast } from '../../components/Toast/ToastContext';
import Vector from '../../assets/Vector.png'

function CommonTable({ columns, data=[], tableHeader, className, enableSorting=false, columnsToInclude, columnMapping, tableName, refVal }) {
      
    // console.log("TableData", data)
    /* istanbul ignore next */
    const downloadExcel = async () => {
        // Transform the data
        const transformedData = data.map(item => {
            const newItem = {};
            columnsToInclude.forEach(col => {
                const originalKey = Object.keys(columnMapping).find(key => columnMapping[key] === col);
                newItem[col] = item[originalKey];
            });
            return newItem;
        });
    
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const dd = String(today.getDate()).padStart(2, "0");
        const formattedDate = `${yyyy}${mm}${dd}`;

        await exportRowsToExcel({
            rows: transformedData,
            headers: columnsToInclude,
            fileName: `${tableName}_${formattedDate}.xlsx`,
            // Conditionally bold the last row if tableName matches
            decorate: sheet => {
                if (tableName.includes("EXECUTIVE SUMMARY FOR THE COVERED 'BUY PLAN' FOR THE YEAR") && sheet.rowCount > 1) {
                    sheet.lastRow.eachCell(cell => {
                        cell.font = { bold: true, name: 'Arial', size: 10 };
                    });
                }
            },
        });
    };



    const componentRef = useRef();
    

    const { showToast } = useToast();

    /* istanbul ignore next */
    const checkPDFDownloaded = (isPdfDownloaded, isModal, fileURL, isExcel, isTable, isJpeg) => {
        if(isPdfDownloaded){
            if(isModal){
                showToast('success', !isJpeg ? "PDF of full page successfully downloaded." : 'JPEG of full page successfully downloaded.', {
                    icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
                });
            } else if(isTable){
                showToast('success', !isJpeg ? "PDF of a table successfully downloaded." : 'JPEG of a table successfully downloaded.', {
                    icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
                });
            }
            else{
                showToast('success', !isJpeg ? "PDF of a chart successfully downloaded.": 'JPEG of a chart successfully downloaded.', {
                    icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
                });
            }
        }
        else if(isExcel){
            downloadExcel()
        }
        else{
            showToast('Error', "Failed to download. Please try again.", {
                icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
            });
        }   
    }
    
    const commonTableClassName = className + " common-table"
    return (
        <div className={commonTableClassName}  ref={componentRef}>
            
	        {/* <button type="primary" title='Download Data' onClick={downloadExcel}  className={tableName == "EXECUTIVE SUMMARY FOR THE COVERED 'BUY PLAN' FOR THE YEAR 2024" ? "download-excel-compass-executive-summary" : tableName === "WEIGHTED AVG. COMPARISON OF PURCHASE COST VS SHOULD COST" ? "download-excel-scm" : "download-excel"}>
							<img src={download_logo} alt="download_logo" style={{position: 'relative', top: '2px'}}/>
			</button> */}
            {/* <button onClick={handleDomToImgDownloadPdf} >
                PDF
            </button> */}
            <span style={tableName === "PROJECT DETAILS" ? {float: 'right', position: 'relative', top: '1rem', zIndex: '9999', right: '2.5rem'} : {float: 'right', position: 'relative', top: '1rem', zIndex: tableName === "Commodity Indices Details" || tableName == 'RESPONSE DETAILS' || tableName == 'Contract Boards details' ? '9' : '9999', right: '0.3rem'}}>
			    <DropdownWithIcons modalRef={componentRef} kpiName={tableHeader} checkPDFDownloaded={checkPDFDownloaded} isTable={true}/>
		    </span>
            {
                tableName === "WEIGHTED AVG. COMPARISON OF PURCHASE COST VS SHOULD COST" ? (
                    <>
                    <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                    <InfoIcon  style={{position: 'relative', top: '2rem', left: '45rem', zIndex: "1000"}}
                                                   text={`For Corrugates (PBNA): SGA Cost = Overhead; R&D = Indirect
                                                   For Cans: Value Add Discrete + Process = Value Add Discrete
                                                   For Preform and Bottle: Preassembly by Internal = Value Add Discrete`} />
                    </div>
                        
                    </>
                ) : tableName === "PROJECT DETAILS" ? (
                    <>
                    <div className="total-spend-xaxis-label" style={{ width: "100%", textAlign: "left" }}>
                    <InfoIcon  style={{position: 'relative', top: '1.8rem', left: '1.8rem', zIndex: "99999", float: 'right'}}
                                                   text={`Download/Extract data at the Event level`} direction={'left'} />
                    </div>
                        
                    </>
                ) : <></>
            }
            {/* {
                tableName == "RESPONSE DETAILS" ? (
                    <>
                        <div className='kpi-card-title'>Respnse Details</div>
                        <span style={{position: 'relative', top: '2rem', zIndex: '9999'}}>Last Updated: </span>
                    </>
                ) : <></>
            } */}

            
            
            <DataTable
                // key={JSON.stringify(columns)}
                columns={columns}
                data={data}
                // filters={false}
                // isDark={false}
                isExpandable={false}
                enableSorting={enableSorting}
                pageIndex={0}
                pageSize={10}
                selection="single"
                size="large"
                tableDescription=""
                // tableHeader={tableName == "RESPONSE DETAILS" ? "" : tableHeader}
                tableHeader={tableHeader}
                showColumnFilters={false}
            />


            
        </div>
    )
}

export default CommonTable